module.exports = __webpack_public_path__ + "static/img/Teagan-Micah.09e537f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Teagan-Micah.jpg
// module id = E27y
// module chunks = 0